import clsx from "clsx";
import Warning from "../../src/assets/svg/warning.svg";

export interface FormInputProps {
  name: string;
  placeholder: string;
  required: boolean;
  value: string;
  type?: string;
  readOnly?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  width?: string;
  className?: string;
  errors?: string[];
  inputRefs: React.MutableRefObject<Record<string, HTMLInputElement | null>>;
}

export function FormInput(props: FormInputProps) {
  const {
    name,
    placeholder,
    required = true,
    type = "text",
    readOnly,
    value,
    onChange,
    width,
    className,
    errors,
    inputRefs,
  } = props;

  const isError = errors && errors.includes(name);

  return (
    <div className="flex flex-col gap-2">
      <label
        htmlFor={name}
        className="text-[15px] text-gray-extra-dark opacity-80"
      >
        {name}
        {required && (
          <span className="text-[14px] font-medium pl-1 text-warning-red">
            *
          </span>
        )}
      </label>
      <div className="flex flex-col gap-1">
        <input
          ref={(el) => (inputRefs.current[name] = el)}
          type={type}
          id={name}
          name={name}
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          maxLength={50}
          pattern={type === "email" ? "^[^s@]+@[^s@]+.[^s@]+$" : ""}
          className={clsx(
            "inline-flex w-full justify-between rounded-md border p-3 focus:border-primary-blue appearance-none focus:outline-none text-base text-gray-extra-dark",
            isError ? "border-warning-red" : "border-extra-light",
            width,
            className,
            readOnly &&
              "bg-input-gray text-opacity-50 focus:!border-extra-light"
          )}
        />
        {isError && (
          <div className="flex items-center gap-1 text-sm text-warning-red">
            <img src={Warning} alt="Warning" />
            Ovo polje je obavezno.
          </div>
        )}
      </div>
    </div>
  );
}

export default FormInput;
